var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-select', { attrs: { "popper-class": "web-previewer-popper", "placeholder": "预览版本" }, model: { value: _vm.currentGroup, callback: function callback($$v) {
        _vm.currentGroup = $$v;
      }, expression: "currentGroup" } }, _vm._l(_vm.options, function (group) {
    return _c('el-option-group', { key: group.label, attrs: { "label": group.label } }, _vm._l(group.options, function (item) {
      return _c('el-option', { key: item.value, attrs: { "label": item.name, "value": item.name } });
    }), 1);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };